import React, { useCallback, useEffect } from 'react';
import { useQueryClient } from 'react-query';
import useFlatMetersAttachments from '../../../../../queries/useFlatMeterAttachments';
import { useAddFlatMeterAttachments } from '../../../../../requests/addFlatMeterAttachments';
import useDeleteFlatMeterAttachment from '../../../../../requests/deleteFlatMeterAttachment';
import getFlatMeterAttachment from '../../../../../requests/getFlatMeterAttachment';
import { getBlobUrl } from '../../../../../../../helpers/getBlobUrl';
import AttachmentsContainer from '../AttachmentsContainer/AttachmentsContainer';
import { getQueryKeys } from '../../../../../queries/queryKeys';

const MeterAttachments = ({ meter, addressId }) => {
  const queryClient = useQueryClient();

  const { data: attachments, isFetching: isAttachmentsFetching } =
    useFlatMetersAttachments(meter.id, { staleTime: 60000 });

  const { addAttachments, loading: addAttachmentsLoading } =
    useAddFlatMeterAttachments();

  const handleAddAttachments = ({ file }) => {
    addAttachments({
      meterId: meter.id,
      files: [{ originFileObj: file, fileType: 'file' }],
    });
  };

  const { deleteAttachment, loading: deleteAttachmentLoading } =
    useDeleteFlatMeterAttachment();

  const handleDeleteAttachment = (attachment) => {
    deleteAttachment({ meterId: meter.id, attachId: attachment.id });
  };

  const getAttachmentUrl = async (data) => {
    const fileName = typeof data === 'string' ? data : data.fileName;

    const fileExtension = fileName.split('.')[1];

    const attachment = await getFlatMeterAttachment(meter.id, fileName);

    const url = getBlobUrl(attachment, fileExtension);

    return url;
  };

  const changesFieldHasAttachment = useCallback(
    (hasAttachment) => {
      queryClient.setQueryData(getQueryKeys.flatMeters(addressId), (oldData) =>
        oldData.map((m) =>
          m.id === meter.id ? { ...m, hasAttachment: hasAttachment } : m
        )
      );
    },
    [queryClient, addressId, meter.id]
  );

  useEffect(() => {
    if (!isAttachmentsFetching) {
      if (!attachments?.length && meter.hasAttachment) {
        changesFieldHasAttachment(false);
      } else if (attachments?.length && !meter.hasAttachment) {
        changesFieldHasAttachment(true);
      }
    }
  }, [
    isAttachmentsFetching,
    attachments,
    meter.hasAttachment,
    changesFieldHasAttachment,
  ]);

  return (
    <AttachmentsContainer
      meter={meter}
      items={attachments}
      title="Вложения"
      loading={isAttachmentsFetching}
      addBtnDisabled={addAttachmentsLoading || deleteAttachmentLoading || meter?.statusId === 5}
      onAddAttachments={handleAddAttachments}
      onDeleteAttachment={handleDeleteAttachment}
      getAttachmentUrl={getAttachmentUrl}
    />
  );
};

export default MeterAttachments;
